module.exports = __webpack_public_path__ + "img/lip.07e3b858.png";